export const authDomains = [
  {
    domain: 'dev-credit-calculator.advance-uac.com',
    userPoolId: 'ap-southeast-2_Mp1l3k978',
    userPoolWebClientId: '1v45q2crrdufc3p37cpniphvk8',
  },
  {
    domain: 'dev-credit-calculator.advance-uac.com.s3-website-ap-southeast-2.amazonaws.com',
    userPoolId: 'ap-southeast-2_Mp1l3k978',
    userPoolWebClientId: '1v45q2crrdufc3p37cpniphvk8',
  },
  {
    domain: 'test-credit-calculator.advance-uac.com',
    userPoolId: 'ap-southeast-2_yIsCAiGwh',
    userPoolWebClientId: '5m42cm9frl8fqsrckmatvi5umu',
  },
  {
    domain: 'test-credit-calculator.advance-uac.com.s3-website-ap-southeast-2.amazonaws.com',
    userPoolId: 'ap-southeast-2_yIsCAiGwh',
    userPoolWebClientId: '5m42cm9frl8fqsrckmatvi5umu',
  },
  {
    domain: 'qa-credit-calculator.advance-uac.com',
    userPoolId: 'ap-southeast-2_ZzKVIq5AJ',
    userPoolWebClientId: '2ap78k95t6pusheinfpt6797tk',
  },
  {
    domain: 'qa-credit-calculator.advance-uac.com.s3-website-ap-southeast-2.amazonaws.com',
    userPoolId: 'ap-southeast-2_ZzKVIq5AJ',
    userPoolWebClientId: '2ap78k95t6pusheinfpt6797tk',
  },
  {
    domain: 'demo-credit-calculator.advance-uac.com',
    userPoolId: 'ap-southeast-2_QRhwUKyme',
    userPoolWebClientId: '3chnkhblf6dm93tkna5iusk9k4',
  },
  {
    domain: 'demo-credit-calculator.advance-uac.com.s3-website-ap-southeast-2.amazonaws.com',
    userPoolId: 'ap-southeast-2_QRhwUKyme',
    userPoolWebClientId: '3chnkhblf6dm93tkna5iusk9k4',
  },
  {
    domain: 'vu-dev2-credit-calculator.advance-uac.com',
    userPoolId: 'ap-southeast-2_fTpU6sQEh',
    userPoolWebClientId: '3p9r17cnk350mc6tgocd4nnji0',
  },
  {
    domain: 'vu-dev2-credit-calculator.advance-uac.com.s3-website-ap-southeast-2.amazonaws.com',
    userPoolId: 'ap-southeast-2_fTpU6sQEh',
    userPoolWebClientId: '3p9r17cnk350mc6tgocd4nnji0',
  },
  {
    domain: 'vu-uat-credit-calculator.advance-uac.com',
    userPoolId: 'ap-southeast-2_zKoi0voaC',
    userPoolWebClientId: '7f66sj6hho1m3p1r6bgmdtf0jl',
  },
  {
    domain: 'vu-uat-credit-calculator.advance-uac.com.s3-website-ap-southeast-2.amazonaws.com',
    userPoolId: 'ap-southeast-2_zKoi0voaC',
    userPoolWebClientId: '7f66sj6hho1m3p1r6bgmdtf0jl',
  },
] as const;

export enum QueryKeys {
  CREDIT_BOOKMARKS = 'CREDIT_BOOKMARKS',
  FORM_SCHEMA = 'FORM_SCHEMA',
  RECENT_INSTITUTION_IDS = 'RECENT_INSTITUTION_IDS',
  REFERENCE_DATA = 'REFERENCE_DATA',
  SELECTED_SOURCE_INSTITUTION = 'SELECTED_SOURCE_INSTITUTION',
  TRANSLATION = 'TRANSLATION',
  URLS = 'URLS',
  INSTITUTION_CODE = 'INSTITUTION_CODE',
}

export enum StorageKey {
  CREDIT_BOOKMARKS = 'credit-bookmarks',
  RECENT_INSTITUTION_IDS = 'recent-institution-ids',
  SELECTED_SOURCE_INSTITUTION = 'selected-source-institution',
}
